// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"81c46674","455":"bf20351e"}[chunkId] + ".chunk.js";
};